import Typography from "@components_v2/typography/typography";
import theme from "@styles/theme";
import { Button, Divider, Grid, MenuItem, Select, Skeleton } from "@mzc-pdc/ui";
import { StyledGrid } from "@components_v2/grid/grid.styled";
import { Breadcrumbs } from "@mui/material";
import { IconArrowDropDown, IconHistory, IconResetSmall, ImageDriveOn, ImageFolderSmallOn } from "@mzc-cloudplex/icons";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const FolderLocation = ({ folderLocation, onClickChange }) => {
    const { t } = useTranslation();

    const parsedFolderLocation = useMemo(() => {
        return folderLocation?.map((item, index) => {
            if (index === 0) return { ...item, icon: <ImageDriveOn width={16} height={16} /> };
            else if (index === folderLocation?.length - 1)
                return {
                    ...item,
                    icon: <ImageFolderSmallOn height={16} width={16} />,
                };
            return item;
        });
    }, [folderLocation]);

    return (
        <>
            {folderLocation?.length > 0 ? (
                <Grid
                    item
                    sx={{
                        alignSelf: "flex-start",
                    }}
                >
                    <Breadcrumbs separator="›">
                        {parsedFolderLocation?.map((folder, index) =>
                            index < folderLocation?.length - 1 ? (
                                <Grid
                                    key={`folder-location-${index}`}
                                    container
                                    flexDirection={"row"}
                                    alignItems={"center"}
                                    gap={0.5}
                                >
                                    {folder.icon}
                                    <Typography color="text.secondary" variant="body3">
                                        {folder.name}
                                    </Typography>
                                </Grid>
                            ) : onClickChange ? (
                                <Button
                                    startIcon={folder.icon}
                                    endIcon={<IconArrowDropDown size={16} />}
                                    color="greySecondary"
                                    onClick={onClickChange}
                                >
                                    <Typography color="text.secondary" variant="body3">
                                        {folder.name}
                                    </Typography>
                                </Button>
                            ) : (
                                <Grid
                                    key={`folder-location-${index}`}
                                    container
                                    flexDirection={"row"}
                                    alignItems={"center"}
                                    gap={0.5}
                                >
                                    {folder.icon}
                                    <Typography color="text.secondary" variant="body3">
                                        {folder.name}
                                    </Typography>
                                </Grid>
                            ),
                        )}
                    </Breadcrumbs>
                </Grid>
            ) : (
                <Button
                    size={"xsmall"}
                    startIcon={<ImageDriveOn width={16} height={16} />}
                    endIcon={<IconArrowDropDown size={16} />}
                    color="greySecondary"
                    onClick={onClickChange}
                    sx={{ px: 0.5, py: 0 }}
                >
                    <Typography variant={"body3"} color={theme.palette.secondary[800]}>
                        {t(`common::label::Drive`, `Drive`)}
                    </Typography>
                </Button>
            )}
        </>
    );
};

export default FolderLocation;
